var locale = {
    placeholder: 'Mangyaring pumili ng oras',
    rangePlaceholder: ['Oras ng pagsisimula', 'Oras ng Pagtatapos']
};
export default locale;